
// export default InfoPage;
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function InfoPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div style={{ maxWidth: "1000px", margin: "0 auto", padding: "20px", fontFamily: "Arial, sans-serif", display: "flex", flexDirection: "column", alignItems: "center" }}>
      
      {/* ファーストビュー（オーバーレイ化） */}
      <div style={{ position: "relative", width: "100%", maxWidth: "1000px", marginBottom: "40px" }}>
        {/* 画像 */}
        <img src="/images/firstview.webp" alt="AI Line Bot Promo" style={{ width: "100%", borderRadius: "10px", filter: "brightness(60%)" }} />
        
        {/* テキストオーバーレイ */}
        <div style={{
          position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
          textAlign: "center", color: "#fff", width: "90%", maxWidth: "800px"
        }}>
          <h1 style={{ fontSize: "36px", fontWeight: "bold", marginBottom: "10px", textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)" }}>
            5分でLINE AI Botを作成！
          </h1>
          <p style={{ fontSize: "20px", marginBottom: "20px", textShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)" }}>
            エンジニア不要！リアルタイムで応答を変更でき、誰でも簡単に運用可能。<br />
            LINE公式アカウントを活用し、**顧客対応・FAQ・マーケティングの自動化を実現**。
          </p>
          <button style={{
            padding: "12px 20px", fontSize: "18px", backgroundColor: "#007BFF", color: "#fff",
            border: "none", borderRadius: "5px", cursor: "pointer"
          }}>
            デモを見る
          </button>
        </div>
      </div>

      {/* 動画埋め込み（ファーストビューの下） */}
      <div style={{ width: "100%", maxWidth: "800px", marginBottom: "40px", textAlign: "center" }}>
        <h2 style={{ color: "#333", fontSize: "24px", marginBottom: "10px" }}>AI Line Bot の使い方</h2>
        <p>動画で簡単な操作方法をご紹介！</p>
        <iframe
          width="100%" height="400px"
          src="https://www.youtube.com/embed/動画のID" // ← ここに動画のURLを入れる
          title="AI Line Bot Demo"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      {/* その他のセクション */}
      <nav style={{ marginBottom: "20px" }}>
        <ul style={{ listStyle: "none", padding: 0, display: "flex", justifyContent: "center", gap: "20px", fontSize: "18px" }}>
          <li><a href="/info#ai-line-bot" style={{ textDecoration: "none", color: "#007BFF" }}>AI LINE BOTとは？</a></li>
          <li><a href="/info#how-to" style={{ textDecoration: "none", color: "#007BFF" }}>操作方法</a></li>
          <li><a href="/info#use-cases" style={{ textDecoration: "none", color: "#007BFF" }}>活用事例</a></li>
          <li><a href="/info#pricing" style={{ textDecoration: "none", color: "#007BFF" }}>料金プラン</a></li>
        </ul>
      </nav>

      {/* 各セクション */}
      {/* <section id="ai-line-bot" style={{ width: "100%", maxWidth: "800px", marginBottom: "40px", padding: "20px", border: "2px solid #ccc", borderRadius: "10px", backgroundColor: "#f9f9f9" }}>
        <h2 style={{ color: "#333" }}>AI LINE BOT とは？</h2>
        <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
          AI LINE BOTは、**誰でも簡単にLINE上で自動応答AIを運用できるツール** です。
          <br />カスタマーサポート、予約受付、マーケティング、社内FAQなど、多様な用途に対応。
          <br />特別なプログラミングスキルは不要で、**直感的なUIから自由にカスタマイズ可能**。
        </p>
      </section> */}
{/* 各セクション */}
<section id="ai-line-bot" style={{ width: "100%", maxWidth: "800px", marginBottom: "40px", padding: "20px", border: "2px solid #ccc", borderRadius: "10px", backgroundColor: "#f9f9f9" }}>
  <h2 style={{ color: "#333" }}>AI LINE BOT とは？</h2>
  <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
    AI LINE BOTは、**誰でも簡単にLINE上で自動応答AIを運用できるツール** です。
    <br />カスタマーサポート、予約受付、マーケティング、社内FAQなど、多様な用途に対応。
    <br />特別なプログラミングスキルは不要で、**直感的なUIから自由にカスタマイズ可能**。
  </p>
</section>

{/* メリットセクション */}
<section id="ai-line-bot-benefits" style={{ width: "100%", maxWidth: "800px", marginBottom: "40px", padding: "20px", border: "2px solid #ccc", borderRadius: "10px", backgroundColor: "#f9f9f9" }}>
  <h2 style={{ color: "#333" }}>🎯 AI LINE BOTのメリット</h2>

  <h3 style={{ color: "#333", marginTop: "20px" }}>📌 1. 費用対効果の高さ</h3>
  <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
    一般的な開発会社や外注に依頼すると、**1回の開発で5万円～10万円以上** の費用がかかり、  
    **修正や機能追加のたびに追加費用** が発生します。  
    <br />
    **AI LINE BOTなら、月額9,800円で自由に編集・運用可能！**  
    さらに、**買い切りプラン（30万円～）** なら、長期的な運用もコストを抑えて実現できます。
  </p>

  <h3 style={{ color: "#333", marginTop: "20px" }}>📌 2. リアルタイムで応答を変更できる</h3>
  <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
    通常のLINE Botは、一度設定すると修正が難しく、**外注するたびに時間とコストがかかります**。  
    **AI LINE BOTなら？**
  </p>
  <ul style={{ fontSize: "16px", lineHeight: "1.8" }}>
    <li><strong>✅ 管理画面でリアルタイムに応答内容を編集</strong></li>
    <li><strong>✅ 特別な知識不要！ノーコードでカスタマイズ可能</strong></li>
    <li><strong>✅ 新しい質問やキャンペーン情報も即反映</strong></li>
  </ul>

  <h3 style={{ color: "#333", marginTop: "20px" }}>📌 3. 自由に売れる！ホワイトラベル対応</h3>
  <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
    AI LINE BOTは、**自社ブランドとして販売OK！**  
    クライアント向けに再販できるので、マーケティング会社やシステム開発会社にも最適です。
  </p>
  <ul style={{ fontSize: "16px", lineHeight: "1.8" }}>
    <li><strong>✅ ホワイトラベル対応！自社ブランドで展開可能</strong></li>
    <li><strong>✅ クライアント向けに再販できるので収益化可能</strong></li>
    <li><strong>✅ カスタム開発も対応（特定業種向けに特化も可能）</strong></li>
  </ul>

  <h3 style={{ color: "#333", marginTop: "20px" }}>📌 4. 運用もすべてお任せ！</h3>
  <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
    「作ったはいいけど、運用が面倒…」そんな悩みも解決！  
    **AI LINE BOTなら、運用代行プランで手間ゼロで運用可能！**
  </p>
  <ul style={{ fontSize: "16px", lineHeight: "1.8" }}>
    <li><strong>✅ 運用サポートプランあり！</strong></li>
    <li><strong>✅ 問い合わせ内容を分析し、継続的に改善可能</strong></li>
    <li><strong>✅ 運用の手間をかけずに、自動で高精度の対応を維持</strong></li>
  </ul>

  {/* CTA（行動を促す） */}
  <div style={{ textAlign: "center", marginTop: "20px" }}>
    <button style={{
      padding: "12px 20px", fontSize: "18px", backgroundColor: "#007BFF", color: "#fff",
      border: "none", borderRadius: "5px", cursor: "pointer"
    }}>
      今すぐデモを試す
    </button>
  </div>
</section>

      {/* <section id="how-to" style={{ width: "100%", maxWidth: "800px", marginBottom: "40px", padding: "20px", border: "2px solid #ccc", borderRadius: "10px", backgroundColor: "#f9f9f9" }}>
        <h2 style={{ color: "#333" }}>操作方法</h2>
        <p>最短5分で設定完了！直感的な管理画面で簡単にAI Botを運用できます。</p>
        <ul style={{ fontSize: "16px", lineHeight: "1.8" }}>
          <li><strong>アカウント作成 & ログイン:</strong> メールアドレスまたはLINEアカウントで簡単登録。</li>
          <li><strong>基本設定の入力:</strong> ボットの名前・アイコン・応答内容を設定。</li>
          <li><strong>受け答え設定:</strong> AIの応答をカスタマイズし、用途に合わせて調整。</li>
          <li><strong>動作確認 & 調整:</strong> 実際に試して、必要に応じて修正。</li>
        </ul>
      </section> */}
<section id="how-to" style={{ width: "100%", maxWidth: "800px", marginBottom: "40px", padding: "20px", border: "2px solid #ccc", borderRadius: "10px", backgroundColor: "#f9f9f9", textAlign: "center" }}>
  <h2 style={{ color: "#333" }}>操作方法</h2>
  <p>最短5分で設定完了！動画で流れを確認できます。</p>

  {/* YouTube動画埋め込み */}
  <div style={{ marginTop: "20px", position: "relative", width: "100%", paddingBottom: "56.25%", height: 0 }}>
    <iframe 
      src="https://www.youtube.com/embed/動画のID" // ← ここにYouTubeの動画URLをセット
      title="AI LINE BOT 設定方法"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", borderRadius: "10px" }}
    ></iframe>
  </div>
</section>

      {/* <section id="use-cases" style={{ width: "100%", maxWidth: "800px", marginBottom: "40px", padding: "20px", border: "2px solid #ccc", borderRadius: "10px", backgroundColor: "#f9f9f9" }}>
        <h2 style={{ color: "#333" }}>活用事例</h2>
        <p>さまざまな業種で活用可能！</p>
        <ul style={{ fontSize: "16px", lineHeight: "1.8" }}>
          <li><strong>ECサイト:</strong> 24時間自動応答で顧客対応を効率化。</li>
          <li><strong>美容院・サロン:</strong> 予約受付やリマインダーを自動化。</li>
          <li><strong>小売業:</strong> 商品案内やクーポン配布に活用。</li>
          <li><strong>社内FAQ:</strong> 従業員向けの情報共有を自動化。</li>
        </ul>
      </section> */}

      {/* <section id="pricing" style={{ width: "100%", maxWidth: "800px", marginBottom: "40px", padding: "20px", border: "2px solid #ccc", borderRadius: "10px", backgroundColor: "#f9f9f9" }}>
        <h2 style={{ color: "#333" }}>料金プラン</h2>
        <p>お客様のニーズに応じた柔軟なプランを提供！</p>
        <ul style={{ fontSize: "16px", lineHeight: "1.8" }}>
          <li><strong>無料プラン:</strong> 基本機能のみ（AI応答数制限あり）。</li>
          <li><strong>スタンダード（月額 9,800円）:</strong> 商用利用OK、応答数無制限。</li>
          <li><strong>ビジネス（月額 29,800円）:</strong> チーム機能、高度なカスタマイズ対応。</li>
          <li><strong>買い切りプラン（300,000円～）:</strong> ホワイトラベル対応、長期運用向け。</li>
        </ul>
      </section> */}
<section id="pricing" style={{ width: "100%", maxWidth: "800px", marginBottom: "40px", padding: "20px", border: "2px solid #ccc", borderRadius: "10px", backgroundColor: "#f9f9f9", textAlign: "center" }}>
  <h2 style={{ color: "#333" }}>料金プラン</h2>
  <p>お客様のニーズに応じた柔軟なプランを提供！</p>

  {/* 料金プラン一覧 */}
  <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap", marginTop: "20px" }}>
    {/* サブスクプラン */}
    <div style={{ width: "45%", padding: "20px", border: "2px solid #007BFF", borderRadius: "10px", backgroundColor: "#eef4ff" }}>
      <h3 style={{ color: "#007BFF" }}>サブスクリプション</h3>
      <p><strong>月額 9,800円～</strong></p>
      <ul style={{ textAlign: "left", fontSize: "16px", lineHeight: "1.8" }}>
        <li>✅ **1アカウントで5ボットまで作成可能**</li>
        <li>✅ 商用利用OK</li>
        <li>✅ AI応答数無制限</li>
        <li>✅ チーム機能（ビジネスプラン 29,800円）</li>
      </ul>
    </div>

    {/* 買い切りプラン */}
    <div style={{ width: "45%", padding: "20px", border: "2px solid #28A745", borderRadius: "10px", backgroundColor: "#eaffea" }}>
      <h3 style={{ color: "#28A745" }}>買い切りプラン</h3>
      <p><strong>300,000円</strong></p>
      <ul style={{ textAlign: "left", fontSize: "16px", lineHeight: "1.8" }}>
        <li>✅ **1アカウントで5ボットまで作成可能**</li>
        <li>✅ ホワイトラベル対応</li>
        <li>✅ 長期運用向け</li>
        <li>✅ 自社ブランドとして販売OK</li>
      </ul>
    </div>
  </div>

  {/* 追加オプション */}
  <h3 style={{ color: "#333", marginTop: "30px" }}>追加オプション</h3>
  <ul style={{ textAlign: "left", fontSize: "16px", lineHeight: "1.8", display: "inline-block", }}>
    <li>🛠 **追加ボット（個別見積もり or 定額プラン）**</li>
    <li>📊 **AI活用コンサルティング対応**</li>
  </ul>

  {/* CTA */}
  <div style={{ textAlign: "center", marginTop: "20px" }}>
    <button style={{
      padding: "12px 20px", fontSize: "18px", backgroundColor: "#007BFF", color: "#fff",
      border: "none", borderRadius: "5px", cursor: "pointer"
    }}>
      詳細を問い合わせる
    </button>
  </div>
</section>
      
    </div>
  );
}

export default InfoPage;
